<template>
  <v-list class="md-primary">
    <v-list-item
      v-for="(item, index) in mutableItems"
      :key="item.id || index"
      :class="{disabled: item.disabled || item.active === false}"
      class="md-layout border"
      @click="$emit('dispatch', $event, index)"
    >
      <v-list-item-title>
        <a
          href="#"
        >
          <h2 class="mb-1 md-title">
            {{ item.title }}
          </h2>
          <span>{{ item.subtitle }}</span>
        </a>
      </v-list-item-title>
      <v-icon
        v-if="!item.disabled"
        class="md-layout-item md-icon-button md-list-action"
      >
        {{ icon }}
      </v-icon>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
    name: 'ListWithSubtitles',
    props: {
        items: {
            type: Array,
            required: true,
        },
        icon: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            mutableItems: null,
        };
    },
    watch: {
        items: {
            handler(items) {
                this.mutableItems = items;
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss" scoped >
  .disabled {
    background: #dddddd;
  }
</style>
